/*
export const config = {
    backendUrl: 'https://gestorauto.elroble.com/api',
    appUrl: 'https://gestorauto.elroble.com/',
    ssoUrl: 'https://sso.elroble.com/',
    ssoToken: 'c7d619901fbcb92a7d93efa3988414af2ba75b9a26c21c9ef1d68aa8ba0f',
    appVersion: "3.2.1"
};
*/


export const config = {
    backendUrl: 'https://qa02gestorauto.seguroselroble.com/api',
    appUrl: 'https://qa02gestorauto.seguroselroble.com/',
    ssoUrl: 'https://gsso.seguroselroble.com/',
    ssoToken: '2c98aa5bd830386fee65ccdf435f7baeea50b3236ae53fcdb3890c13fbe1',
    appVersion: "3.2.8"
};
// comentario
